import { render, staticRenderFns } from "./inserirItemModal.vue?vue&type=template&id=5c379e16&"
import script from "./inserirItemModal.vue?vue&type=script&lang=js&"
export * from "./inserirItemModal.vue?vue&type=script&lang=js&"
import style0 from "./inserirItemModal.vue?vue&type=style&index=0&id=5c379e16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports